module.exports = __webpack_public_path__ + "static/tewari-7dc1494824927ba62cdb8db1af251611.png";